import styles from "./index.module.scss";

export const None = () => {
  return <div className={styles.box} />;
};
